<template>
    <modal :value="value"
           max-width="500"
           :title="$t('message.leads.message.tableFields')"
           content-class="modal modal-round"
           @input="emitShowing">

        <template #default>
            <div class="header">
                <h1>{{$t('message.generics.message.name')}}</h1>
            </div>   
            
            <vue-nestable v-model="listData"
                        keyProp="identifier"  
                        :maxDepth="1"
                        @change="changeColumnsPosition">     
                <div class="item" slot-scope="{item}">
                    <vue-nestable-handle  :item="item">
                        <i class="mdi mdi-drag"></i>
                    </vue-nestable-handle>
                    <div class="name-wrapper">
                        <span>
                            {{ item.label }}
                        </span>
                        <input v-model="item.showing" type="checkbox" @input="setColumShowing">
                    </div>                                 
                </div>
            </vue-nestable>
        </template>   
           
        <template #footer>
            <div class="button-wrapper">
                <button class="btn btn-extra-round btn-primary" @click="setColumnsToShow">
                    {{$t('message.generics.message.save')}}
                </button>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@components/generic/Modal.vue";
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import EventBus from "../../../../../../packages/event-bus";

export default {
    components: {
        Modal,
        VueNestable,
        VueNestableHandle,        
    },

    data() {
        return {            
            loading: false,
            extraFields: [],
            columnsToShow: [],
            listData: [],            
        }
    },   

    props: {        
        value: {
            type: Boolean,
            default: false,
        },        
        list: {
            type: Array,
            default: () => {
                return [];
            },
        }
    },

    watch: {
        value(val) {
            if(val) {
                const integratedList = this.isAdminAndIsNotLoggedAs ? [...this.columns] : [...this.columns, ...this.list]
                const integratedListWithoutDuplicates = integratedList.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.name === value.name && t.id === value.id
                    ))
                )
                this.listData = integratedListWithoutDuplicates.map((item) => {
                    return {
                        ...item,
                        identifier: `${item.type}-${item.id}`,
                        children: [],
                    }
                })
                
            }
        }
    },

    computed: {        
        headers() {
            return [
                { text: "", value: "", sortable: false, width: 50 },
                { text: this.$t('message.generics.message.name'), value: "name", sortable: false },
                { text: "", value: "", sortable: false },
            ]
        },
        columns() {
            return this.isAdminAndIsNotLoggedAs ? this.$store.state.leads.columnsToShowAdmin : this.$store.state.leads.columnsToShow
        },
        columnsNamesToBeSetAsCookies() {
            const arrayWithColumnsNames = []
            this.columnsToShow.map(item => item.showing && arrayWithColumnsNames.push(item.name))
            return JSON.stringify(arrayWithColumnsNames)
        },
        establishmentId() {
            return this.$store.state.users.user ? this.$store.state.users.user.accountId : null
        },
        isAdmin() {
            return this.$store.state.users.admin;
        },
         user() {
            return !!this.$store.state.users.user;
        },
        isAdminAndIsNotLoggedAs() {
            return (this.isAdmin && !this.user)
        }       
    },

    methods: {
        changeColumnsPosition(value, options) {            
            this.columnsToShow = options.items
        },
        setColumShowing() {
            this.columnsToShow = this.listData
        },
        setColumnsToShow() {
            this.isAdminAndIsNotLoggedAs ? this.$store.commit("LEADS_SET_COLS_TO_SHOW_ADMIN", this.columnsToShow) : this.$store.commit("LEADS_SET_COLS_TO_SHOW", this.columnsToShow);
            const daysToExpire = new Date(2147483647 * 1000).toUTCString();
            if(this.establishmentId) {
                document.cookie = encodeURIComponent(`registration-table-${this.establishmentId}`) + "=" + encodeURIComponent(JSON.stringify(this.columnsToShow)) + '; expires=' + daysToExpire + '; path=/'
            } else {
                document.cookie = encodeURIComponent(`registration-table-admin`) + "=" + encodeURIComponent(JSON.stringify(this.columnsToShow)) + '; expires=' + daysToExpire + '; path=/'
            }
            this.emitShowing(false)
            EventBus.$emit("show-message", {
                type: "SUCCESS",
                message: "Tabela alterada com sucesso"
            });
        },        
        emitShowing(value) {
            this.$emit("input", value);
        },        
        getCookie(cName) {
            const name = cName + "=";
            const cDecoded = decodeURIComponent(document.cookie); 
            const cArr = cDecoded.split('; ');
            let res;
            cArr.forEach(val => {                
                if (val.indexOf(name) === 0) res = val.substring(name.length);
            })
            return res
        }
    },
    
    async created() {        
        const columnsNamesAlreadySetAsCookies = this.establishmentId ? this.getCookie(`registration-table-${this.establishmentId}`) : this.getCookie(`registration-table-admin`)
        if(columnsNamesAlreadySetAsCookies) {
            const columnsNamesAlreadySetAsCookiesArray = JSON.parse(columnsNamesAlreadySetAsCookies)       
            this.isAdminAndIsNotLoggedAs ? this.$store.commit("LEADS_SET_COLS_TO_SHOW_ADMIN", columnsNamesAlreadySetAsCookiesArray) : this.$store.commit("LEADS_SET_COLS_TO_SHOW", columnsNamesAlreadySetAsCookiesArray);
        } else {
            if(!this.isAdminAndIsNotLoggedAs)
                this.$store.commit("LEADS_RESET_COLS_TO_SHOW")
        }
    }  
    
   
}
</script>

<style lang="scss" scoped>

.nestable {
    max-height: 350px;
    padding-right: 10px;
}

.nestable-handle {
    padding-bottom: 12px;
}

.header {
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    margin-left: 32px;
    margin-bottom: 10px;
    margin-right: 12px;

    h1 {
        font-size: 15px;
    }
}


.item {
    display: flex;
    align-items: center;
    gap: 8px;
   
    .mdi {
        font-size: 24px;
    }

    .name-wrapper {
        border-bottom: 1px solid #c8c8c8;
        width: 100%;
        padding-bottom: 12px;
        display: flex;
        justify-content: space-between;

        input {
            cursor: pointer;
        }
        
    }
}

.button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 25px;
}

.modal-round .v-card .card-body {
    min-height: 160px;
}

.modal h1 {
    margin-bottom: 0;
}
</style>
